/* ==========================================================================
   Headband Offer
   - copy-to-clipboard for the discount code
   - dismissible header bar
   - "Add my free headband" -> POST /cart/add.js, then apply the code

   Shopify's Buy X Get Y discount can only reduce the price of an item already
   in the basket; it cannot add one. Without the headband in the cart the code
   is rejected outright ("discount code isn't valid for the items in your
   cart"). The button therefore does both steps for the customer: it adds the
   headband, then hands off to /discount/<CODE> so the code is applied to the
   session and nothing is left to do at checkout.

   Everything is delegated on `document` so markup re-rendered by the AJAX cart
   keeps working without re-binding.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__hboInit) return;
  window.__hboInit = true;

  var COPIED_MS = 2000;

  function rootPath() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  /* ---- Clipboard -------------------------------------------------------- */

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () { return true; },
        function () { return legacyCopy(text); }
      );
    }
    return Promise.resolve(legacyCopy(text));
  }

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);

    var ok = false;
    try {
      ta.select();
      ta.setSelectionRange(0, ta.value.length);
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(ta);
    return ok;
  }

  function announce(chip, message) {
    var live = chip.querySelector('[data-hbo-live]');
    if (live) live.textContent = message;
  }

  function flashCopied(chip) {
    var label = chip.getAttribute('data-hbo-copied-label') || 'Copied';
    var idle = chip.getAttribute('data-hbo-idle-label') || 'Copy code';

    chip.classList.add('is-copied');
    chip.setAttribute('aria-label', label);
    announce(chip, label);

    if (chip.__hboTimer) clearTimeout(chip.__hboTimer);
    chip.__hboTimer = setTimeout(function () {
      chip.classList.remove('is-copied');
      chip.setAttribute('aria-label', idle);
      announce(chip, '');
    }, COPIED_MS);
  }

  function selectNode(node) {
    if (!node || !window.getSelection || !document.createRange) return;
    var range = document.createRange();
    range.selectNodeContents(node);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  document.addEventListener('click', function (event) {
    var chip = event.target.closest ? event.target.closest('[data-hbo-copy]') : null;
    if (!chip) return;

    event.preventDefault();

    var code = chip.getAttribute('data-hbo-copy');
    if (!code) return;

    copyText(code).then(function (ok) {
      if (ok) {
        flashCopied(chip);
      } else {
        announce(chip, 'Press Ctrl+C or Cmd+C to copy');
        selectNode(chip.querySelector('.hbo-code__value') || chip);
      }
    });
  });

  /* ---- Add the free headband, then apply the code ----------------------- */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-hbo-add]') : null;
    if (!btn || btn.disabled) return;

    event.preventDefault();

    var variantId = parseInt(btn.getAttribute('data-hbo-add'), 10);
    if (!variantId) return;

    var code = btn.getAttribute('data-hbo-code');
    var label = btn.querySelector('.hbo-btn__label');
    var idleText = btn.getAttribute('data-hbo-idle-label') || 'Add my free headband';
    var addingText = btn.getAttribute('data-hbo-adding-label') || 'Adding...';
    var errorEl = btn.parentNode ? btn.parentNode.querySelector('[data-hbo-error]') : null;

    btn.disabled = true;
    btn.classList.add('is-loading');
    if (label) label.textContent = addingText;
    if (errorEl) errorEl.hidden = true;

    fetch(rootPath().replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add-to-cart failed: ' + response.status);
        return response.json();
      })
      .then(function () {
        var back = window.location.pathname + window.location.search;

        if (code) {
          // Applying the code to the session here means the customer has
          // nothing to paste at checkout. Shopify silently no-ops if the code
          // can't apply, and we still land back on the cart either way.
          window.location.href = rootPath().replace(/\/$/, '') +
            '/discount/' + encodeURIComponent(code) +
            '?redirect=' + encodeURIComponent(back);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (label) label.textContent = idleText;
        if (errorEl) errorEl.hidden = false;
      });
  });

  /* ---- Dismiss the header bar ------------------------------------------- */

  function storageKey(bar) {
    return 'hbo-dismissed:' + (bar.getAttribute('data-hbo-version') || 'v1');
  }

  function safeGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function safeSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-hbo-dismiss]') : null;
    if (!btn) return;

    var bar = btn.closest('[data-hbo-bar]');
    if (!bar) return;

    event.preventDefault();
    bar.classList.add('is-dismissing');
    safeSet(storageKey(bar), '1');

    setTimeout(function () { bar.hidden = true; }, 200);
  });

  function applyDismissed() {
    if (window.Shopify && window.Shopify.designMode) return;

    var bars = document.querySelectorAll('[data-hbo-bar][data-hbo-dismissible="true"]');
    Array.prototype.forEach.call(bars, function (bar) {
      if (safeGet(storageKey(bar)) === '1') bar.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDismissed);
  } else {
    applyDismissed();
  }

  document.addEventListener('shopify:section:load', applyDismissed);
})();
